import { ReactNode } from 'react';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type EligibilityPageHeadingProps = {
  productName: string;
  children: ReactNode;
};

// The product-name eyebrow and the page H1 as a single title block, so the gap
// between them is controlled in one place (24px / `xlarge`) across every step of
// the eligibility flow. The H1 is passed as children so each step keeps ownership
// of its heading text/markup.
function EligibilityPageHeading({ productName, children }: EligibilityPageHeadingProps) {
  return (
    <Stack gap="xlarge">
      <Text size="standard" tone="muted" weight="regular">
        {productName}
      </Text>
      {children}
    </Stack>
  );
}

export default EligibilityPageHeading;
